import { render } from "./TeamingScroller.vue?vue&type=template&id=bc6b8b2a&scoped=true"
import script from "./TeamingScroller.vue?vue&type=script&lang=js"
export * from "./TeamingScroller.vue?vue&type=script&lang=js"

import "./TeamingScroller.vue?vue&type=style&index=0&id=bc6b8b2a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bc6b8b2a"

export default script